import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  GET_TRANSACTION_HISTORY,
  GET_WALLET_INFO,
} from "../../../services/ApiCalls";
import TransactionTable from "../../../components/transactionHistory/TransactionTable";
import { toast } from "react-toastify";


const TransactionHistory = () => {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
    status: "all",
  });
  const getData = async (body) => {
    setLoader(true);
    try {
      const res = await GET_TRANSACTION_HISTORY(body);

      if (res?.data?.status === "success") {
        setData(res.data.data.transactions);
        setTotalCount(res?.data?.data?.totalCount || 0);
        setLoader(false);
      } else {
        toast.error(res?.data?.message);
        setLoader(false);
      }
    } catch (error) {
      toast.error("something went wrong");
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!body.search.trim()) getData(body);
  }, [body.search]);

  return (
    <>
      <section className="transactionHistory py-2 position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="sectionHeader">
                <h3 className="m-0 fw-sbold themeBlue">Transaction History</h3>
              </div>
            </Col>
            <TransactionTable
              data={data}
              totalCount={totalCount}
              body={body}
              loader={loader}
              reFetch={getData}
              setBody={setBody}
            />
            {/* <PaginationComp
              totalCount={totalCount}
              page={body.page}
              limit={body.limit}
              setBody={setBody}
            /> */}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default TransactionHistory;
